import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';

const propTypes = {
  displayName: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: undefined,
};

const FacilityName = ({ className, displayName }) => (
  <span className={className}>{displayName}</span>
);

FacilityName.propTypes = propTypes;
FacilityName.defaultProps = defaultProps;

FacilityName.fragments = {
  facility: gql`
    fragment FacilityNameFacility on Facility {
      id
      __typename
      displayName
    }
  `,
};

export default FacilityName;
